import React from "react";

function Terms() {
  return (
    <>
      <div className="py-2 px-4 mx-auto max-w-screen-xl lg:py-16">
        <div className="container mx-auto p-6 mt-20">
          <h1 className="mb-4 mt-2 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-4xl lg:text-4xl dark:text-white">
            Terms and Conditions
          </h1>
          <p>Welcome to CurioCodeSolution!</p>
          <p className="mt-4">
            These terms and conditions outline the rules and regulations for the
            use of CurioCodeSolution's Website, located at{" "}
            <a
              href="https://curiocodesolution.netlify.app/"
              className="text-blue-500 underline"
            >
              https://www.curiocode.com
            </a>
            .
          </p>
          <p>
            By accessing this website, we assume you accept these terms and
            conditions. Do not continue to use CurioCodeSolution if you do not
            agree to take all of the terms and conditions stated on this page.
          </p>
          <h2 className="mt-3 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            Cookies:
          </h2>
          <p>
            The website uses cookies to help personalize your online experience.
            By accessing CodSoft, you agreed to use the required cookies. A
            cookie is a text file that is placed on your hard disk by a web page
            server. Cookies cannot be used to run programs or deliver viruses to
            your computer. Cookies are uniquely assigned to you and can only be
            read by a web server in the domain that issued the cookie to you. We
            may use cookies to collect, store, and track information for
            statistical or marketing purposes to operate our website. You have
            the ability to accept or decline optional Cookies. There are some
            required Cookies that are necessary for the operation of our
            website. These cookies do not require your consent as they always
            work. Please keep in mind that by accepting required Cookies, you
            also accept third-party Cookies, which might be used via third-party
            provided services if you use such services on our website, for
            example, a video display window provided by third parties and
            integrated into our website.
          </p>
          <h2 className="mt-3 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            License:
          </h2>
          <p>
            Unless otherwise stated, CurioCode Solution and/or its licensors own
            the intellectual property rights for all material on CurioCode
            Solution. All intellectual property rights are reserved. You may
            access this from CurioCode Solution for your own personal use
            subjected to restrictions set in these terms and conditions. You
            must not: Copy or republish material from CurioCode Solution Sell,
            rent, or sub-license material from CurioCode Solution Reproduce,
            duplicate or copy material from CurioCode Solution Redistribute
            content from CurioCode Solution This Agreement shall begin on the
            date hereof. Parts of this website offer users an opportunity to
            post and exchange opinions and information in certain areas of the
            website. CurioCode Solution does not filter, edit, publish or review
            Comments before their presence on the website. Comments do not
            reflect the views and opinions of CurioCode Solution, its agents,
            and/or affiliates. Comments reflect the views and opinions of the
            person who posts their views and opinions. To the extent permitted
            by applicable laws, CurioCode Solution shall not be liable for the
            Comments or any liability, damages, or expenses caused and/or
            suffered as a result of any use of and/or posting of and/or
            appearance of the Comments on this website. CurioCode Solution
            reserves the right to monitor all Comments and remove any Comments
            that can be considered inappropriate, offensive, or causes breach of
            these Terms and Conditions. You warrant and represent that:
            <ol class="list-decimal list-inside">
              <li class="mb-2">
                You are entitled to post the Comments on our website and have
                all necessary licenses and consents to do so
              </li>
              <li class="mb-2">
                The Comments do not invade any intellectual property right,
                including without limitation copyright, patent, or trademark of
                any third party
              </li>
              <li class="mb-2">
                The Comments do not contain any defamatory, libelous, offensive,
                indecent, or otherwise unlawful material, which is an invasion
                of privacy.
              </li>
              <li>
                The Comments will not be used to solicit or promote business or
                custom or present commercial activities or unlawful activity.
              </li>
            </ol>
            You hereby grant CurioCode Solution a non-exclusive license to use,
            reproduce, edit and authorize others to use, reproduce and edit any
            of your Comments in any and all forms, formats, or media.
          </p>
          <h2 className="mt-3 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            Hyperlinking to our Content:
          </h2>
          <div class="mt-8">
            <p class="font-bold">
              The following organizations may link to our Website without prior
              written approval:
            </p>
            <ul class="list-disc list-inside ml-8 mt-2">
              <li>Government agencies;</li>
              <li>Search engines;</li>
              <li>News organizations;</li>
              <li>
                Online directory distributors may link to our Website in the
                same manner as they hyperlink to the Websites of other listed
                businesses; and
              </li>
              <li>
                System-wide Accredited Businesses except soliciting non-profit
                organizations, charity shopping malls, and charity fundraising
                groups which may not hyperlink to our Web site.
              </li>
            </ul>
            <p class="font-bold mt-4">
              These organizations may link to our home page, to publications, or
              to other Website information so long as the link:
            </p>
            <ol class="list-decimal list-inside ml-8 mt-2">
              <li>is not in any way deceptive;</li>
              <li>
                does not falsely imply sponsorship, endorsement, or approval of
                the linking party and its products and/or services; and
              </li>
              <li>fits within the context of the linking party's site.</li>
            </ol>
            <p class="font-bold mt-4">
              We may consider and approve other link requests from the following
              types of organizations:
            </p>
            <ul class="list-disc list-inside ml-8 mt-2">
              <li>
                Commonly-known consumer and/or business information sources;
              </li>
              <li>Dot.com community sites;</li>
              <li>Associations or other groups representing charities;</li>
              <li>Online directory distributors;</li>
              <li>Internet portals;</li>
              <li>Accounting, law, and consulting firms; and</li>
              <li>Educational institutions and trade associations.</li>
            </ul>
            <p class="font-bold mt-4">
              We will approve link requests from these organizations if we
              decide that:
            </p>
            <ol class="list-decimal list-inside ml-8 mt-2">
              <li>
                the link would not make us look unfavorably to ourselves or to
                our accredited businesses;
              </li>
              <li>
                the organization does not have any negative records with us;
              </li>
              <li>
                the benefit to us from the visibility of the hyperlink
                compensates the absence of CODSOFT; and
              </li>
              <li>
                the link is in the context of general resource information.
              </li>
            </ol>
            <p class="font-bold mt-4">
              Approved organizations may hyperlink to our Website as follows:
            </p>
            <ul class="list-disc list-inside ml-8 mt-2">
              <li>By use of our corporate name; or</li>
              <li>
                By use of the uniform resource locator being linked to; or
              </li>
              <li>
                Using any other description of our Website being linked to that
                makes sense within the context and format of content on the
                linking party's site.
              </li>
            </ul>
            <p class="font-bold mt-4">
              No use of CODSOFT's logo or other artwork will be allowed for
              linking absent a trademark license agreement.
            </p>
          </div>
          <h2 className="mt-3 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            Content Liability:
          </h2>
          <p>
            We shall not be held responsible for any content that appears on
            your Website. You agree to protect and defend us against all claims
            that are raised on your Website. No link(s) should appear on any
            Website that may be interpreted as libelous, obscene, or criminal,
            or which infringes, otherwise violates, or advocates the
            infringement or other violation of, any third party rights.
          </p>
          <h2 className="mt-3 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            Disclaimer:
          </h2>
          <div class="text-gray-700">
            <p class="mb-4">
              To the maximum extent permitted by applicable law, we exclude all
              representations, warranties, and conditions relating to our
              website and the use of this website. Nothing in this disclaimer
              will:
            </p>

            <ul class="list-disc list-inside mb-4">
              <li>
                Limit or exclude our or your liability for death or personal
                injury;
              </li>
              <li>
                Limit or exclude our or your liability for fraud or fraudulent
                misrepresentation;
              </li>
              <li>
                Limit any of our or your liabilities in any way that is not
                permitted under applicable law; or
              </li>
              <li>
                Exclude any of our or your liabilities that may not be excluded
                under applicable law.
              </li>
            </ul>

            <p class="mb-4">
              The limitations and prohibitions of liability set in this Section
              and elsewhere in this disclaimer: (a) are subject to the preceding
              paragraph; and (b) govern all liabilities arising under the
              disclaimer, including liabilities arising in contract, in tort,
              and for breach of statutory duty.
            </p>

            <p class="mb-4">
              As long as the website and the information and services on the
              website are provided free of charge, we will not be liable for any
              loss or damage of any nature.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Terms;
